import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import formVersionServer from 'resources/server/FormVersionServer';
import type { PaginationOptions } from 'resources/types/PaginationOptions';
import type { FormVersionPage } from 'store/types';

import type { FormVersionsFilterRequest } from '../../../../resources/types/FormVersionServer';

export const formVersionsQueryKey = 'form-versions';

const useGetFormVersionsQuery = (
  filter: FormVersionsFilterRequest,
  enabled = true,
  pagination?: PaginationOptions
): UseQueryResult<FormVersionPage> => {
  const compoundKey = [formVersionsQueryKey, filter, pagination];

  return useQuery({
    queryKey: compoundKey,
    queryFn: () =>
      formVersionServer.GetFormVersions(filter, {
        page: pagination?.page,
        pageSize: pagination?.pageSize,
      }),
    enabled,
    refetchInterval: 600000,
    refetchIntervalInBackground: true,
    keepPreviousData: true,
  });
};

export default useGetFormVersionsQuery;
